export default "__VITE_ASSET__d2450421__"